"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ungzipStream = void 0;
const pako_1 = require("pako");
function ungzipStream(file) {
    return new ReadableStream({
        start(controller) {
            void file
                .arrayBuffer()
                .then((arrayBuffer) => (0, pako_1.ungzip)(new Uint8Array(arrayBuffer)))
                .then((arrayBuffer) => {
                controller.enqueue(arrayBuffer);
                controller.close();
            });
        },
    });
}
exports.ungzipStream = ungzipStream;
//# sourceMappingURL=ungzipStream.browser.js.map